import { HttpEvent, HttpEventCallbacks, httpPost } from "@/events/eventsDomain";
import { Language } from "@/i18n/languages";
import type { ImportPreview, ImportResult } from "./companyImportDomain";

const base = (accountId: string) =>
  `/enterprise-accounts/${encodeURIComponent(accountId)}/companies/import-excel`;

export const companyImportTemplateUrl = (accountId: string, lang: Language) =>
  `/api${base(accountId)}/template?lang=${lang}`;

const fileForm = (file: File, fields: Record<string, string | string[]> = {}) => {
  const form = new FormData();
  form.append("file", file);
  Object.entries(fields).forEach(([key, value]) =>
    (Array.isArray(value) ? value : [value]).forEach((v) => form.append(key, v)),
  );
  return form;
};

export const companyImportApiClient = {
  preview: (
    accountId: string,
    file: File,
    params: HttpEventCallbacks<ImportPreview>,
  ): HttpEvent<ImportPreview> =>
    httpPost({ url: `${base(accountId)}/preview`, data: fileForm(file), ...params }),
  import: (
    accountId: string,
    file: File,
    adminUserIds: string[],
    params: HttpEventCallbacks<ImportResult>,
  ): HttpEvent<ImportResult> =>
    httpPost({
      url: base(accountId),
      data: fileForm(file, { adminUserIds, acceptTerms: "true" }),
      ...params,
    }),
};
